module.exports = __webpack_public_path__ + "static/img/企业logo4.b547aa24.jpeg";